import { Box, Typography } from '@mui/material';
import { ClickTrackingOptions } from '../../utils/templateConstants';
import TemplateSearchableSelect from '../shared/TemplateSearchableSelect';

export default function TemplateClickTrackingField({ value, onChange, sx }) {
  const selected =
    ClickTrackingOptions.find((opt) => opt.value === value)
    ?? ClickTrackingOptions.find((opt) => opt.value === '1');

  return (
    <Box sx={sx}>
      <TemplateSearchableSelect
        label="Enable Click Tracking"
        options={ClickTrackingOptions}
        value={selected}
        onChange={(opt) => onChange(opt?.value ?? '1')}
        sx={{ mb: 0.5 }}
      />
      <Typography
        component="p"
        variant="caption"
        sx={{ color: 'error.main', fontSize: '0.75rem', mt: 0.5 }}
      >
        *This track only CTA URL
      </Typography>
    </Box>
  );
}
